import {
  Card,
  CardHeader,
  CardContent,
  CardFooter
} from "@/components/ui/card";
import { useTheme } from "../components/ThemeProvider";

const CardShimmer = ({ row = 1, isCompact = false }) => {
  const { resolvedTheme } = useTheme();
  const totalCards = row * 4;

  return (
    <div
      className={`grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4`}
    >
      {Array.from({ length: totalCards }).map((_, idx) => (
        <Card
          key={idx}
          className={`overflow-hidden animate-pulse border h-full flex flex-col ${
            isCompact ? "p-2" : ""
          }`}
        >
          <CardHeader className={`p-0 ${isCompact ? "mb-2" : ""}`}>
            <div
              className={`relative ${isCompact ? "h-24" : "h-40"} ${
                resolvedTheme === "dark" ? "bg-muted" : "bg-slate-300"
              } rounded`}
            />
          </CardHeader>

          <CardContent className={`${isCompact ? "p-1" : "p-4"} flex-grow`}>
            <div
              className={`${isCompact ? "h-3" : "h-4"} ${
                resolvedTheme === "dark" ? "bg-muted" : "bg-slate-300"
              } rounded w-3/4 mb-2`}
            />
            {!isCompact && <div className="h-3 bg-muted rounded w-full mb-2" />}
            <div
              className={`${isCompact ? "h-3" : "h-4"} ${
                resolvedTheme === "dark" ? "bg-muted" : "bg-slate-300"
              } rounded w-1/2`}
            />
          </CardContent>

          {!isCompact && (
            <CardFooter className="p-4 pt-0">
              <div
                className={`h-8 w-full ${
                  resolvedTheme === "dark" ? "bg-muted" : "bg-slate-300"
                } rounded`}
              />
            </CardFooter>
          )}
        </Card>
      ))}
    </div>
  );
};

export default CardShimmer;
